import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { PartyPopper } from "lucide-react";

const KomikNaSylwestra = () => (
  <SeoPageLayout title="Komik na" titleAccent="sylwestra firmowego">
    <SeoSection title="Stand-up na sylwestra firmowego">
      <p>Sylwester firmowy to jedno z najważniejszych wydarzeń w kalendarzu każdej organizacji. To moment, w którym cały zespół świętuje zakończenie roku, podsumowuje osiągnięcia i wchodzi w nowy rok z pozytywną energią. Profesjonalny komik na sylwestrze firmowym dodaje wydarzeniu wyjątkowego charakteru - łączy elegancję wieczoru z autentycznym śmiechem i buduje atmosferę, której nie da się zapomnieć.</p>
    </SeoSection>

    <SeoSection title="Dlaczego komik na sylwestrze firmowym?">
      <SeoStyledList items={[
        "Przełamuje formalność i buduje luźną, świąteczną atmosferę",
        "Humorystyczne podsumowanie roku - sukcesy, wpadki i zabawne momenty",
        "Spersonalizowany materiał nawiązujący do firmy i pracowników",
        "Idealny przerywnik między kolacją a zabawą taneczną",
        "Wspólny śmiech przed odliczaniem do północy",
        "Niezapomniane wspomnienia na start nowego roku"
      ]} />
    </SeoSection>

    <SeoSection title="Format występu sylwestrowego">
      <p>Występ komediowy na sylwestrze firmowym zazwyczaj trwa 30-45 minut i odbywa się w drugiej części wieczoru, po oficjalnych przemówieniach i kolacji. Komik może też pełnić rolę prowadzącego wieczór - zapowiadać toasty, prowadzić odliczanie i łączyć elementy programu humorem. Materiał zawsze nawiązuje do minionego roku w firmie, branży i aktualnych wydarzeń.</p>
    </SeoSection>

    <SeoSection title="Zamów komika na sylwestra">
      <p>Zaplanuj sylwestra firmowego, który Twoi pracownicy zapamiętają na lata. Skontaktuj się z nami z wyprzedzeniem - sylwestrowe terminy rezerwowane są nawet kilka miesięcy wcześniej. Zaproponujemy format idealnie dopasowany do stylu Twojego eventu.</p>
      <SeoHighlightBox icon={PartyPopper}>
        Sylwestrowe terminy znikają najszybciej - zarezerwuj komika na sylwestra nawet kilka miesięcy wcześniej!
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikNaSylwestra;
